import React from "react";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { COMPANY } from "../../data/content";

export const TopBar = () => {
  return (
    <div className="bg-[color:var(--brand-navy)] text-white/90 text-xs sm:text-sm">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-wrap items-center justify-between gap-2">
        <div className="hidden md:flex items-center gap-1.5 text-white/70">
          <MapPin className="h-3.5 w-3.5 shrink-0" />
          <span className="truncate">SIGMA Building, 1st Floor, 93 Hospital Rd., George Town</span>
        </div>
        <div className="flex items-center gap-4 sm:gap-6 flex-wrap">
          <a
            href={COMPANY.phoneHref}
            className="inline-flex items-center gap-1.5 hover:text-white hover:underline transition-colors duration-200"
            data-testid="topbar-phone-link"
          >
            <Phone className="h-3.5 w-3.5" /> {COMPANY.phone}
          </a>
          <a
            href={COMPANY.emailHref}
            className="inline-flex items-center gap-1.5 hover:text-white hover:underline transition-colors duration-200"
            data-testid="topbar-email-link"
          >
            <Mail className="h-3.5 w-3.5" /> {COMPANY.email}
          </a>
          <span className="hidden sm:inline-flex items-center gap-1.5 text-[color:var(--brand-seafoam)]" data-testid="topbar-hours-text">
            <Clock className="h-3.5 w-3.5" /> Mon&ndash;Fri: 9 AM &ndash; 3 PM
          </span>
        </div>
      </div>
    </div>
  );
};
